import React from 'react'
import * as Styled from './styles'

interface Props {
  isExpanded: boolean
  onClick: () => void
  children: React.ReactNode
}

const ExpandCollapseButton: React.FC<Props> = ({ isExpanded, onClick, children }) => {
  return (
    <Styled.ExpandCollapseButton onClick={onClick}>
      <i className={`fal fa-${isExpanded ? 'minus' : 'plus'} fa-lg`} aria-hidden="true" />
      {children}
    </Styled.ExpandCollapseButton>
  )
}

export default ExpandCollapseButton
